/* eslint-disable react/no-array-index-key */
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { observer } from 'mobx-react';
import { Button, Modal, IconButton } from '@mui/material';
import { styled } from '@mui/system';
import { isEmpty } from 'lodash';

import './scss/industry-modal.scss';
import Color from '@tool/color';
import { CloseIcon20 } from '@styled/icon';
import moSingle, {
  changeIndustry, changeSubIndustry, toggleModal,
} from './store/single-industry';

interface IProps {}
interface IState {}

const DButton = styled(Button)(() => ({
  fontWeight: 400,
  lineHeight: 1.5,
  whiteSpace: 'nowrap',
  color: Color.blackColor(0.85),

  '&.active': {
    fontWeight: 500,
    color: Color.primaryColor(1),
    backgroundColor: Color.primaryColor(0.04),
  },
  '&:hover': {
    fontWeight: 500,
    color: Color.primaryColor(1),
    backgroundColor: Color.primaryColor(0.04),
  },
}));

const EButton = styled(DButton)(() => ({
  marginTop: '5px',
  padding: '10px 20px',
}));

const DIconButton = styled(IconButton)(() => ({}));

const CButton = styled(DButton)(() => ({
  width: '100%',
  height: '36px',
}));

const DModal = styled(Modal)(() => ({
  zIndex: 5555555,
}));

const SingleIndustry = (props: IProps, state: IState) => {
  const {
    isModal, industryList, code, currentIndustry,
  } = moSingle;

  useEffect(() => {
    return () => {};
  }, []);

  const onNothing = () => {};

  return (
    <DModal open={isModal} onClose={() => onNothing()}>
      <section className="industry-modal_0110">
        <p className="title-015">
          <span>选择行业</span>
          <DIconButton onClick={() => toggleModal(false)}>
            <CloseIcon20 width={26} height={26} color={Color.blackColor(0.5)} />
          </DIconButton>
        </p>
        <section className="modal-0111">
          <section className="industry-0101">
            {industryList.map((item: any, index: number) => (
              <section key={index} className="industry-0102">
                <CButton
                  onClick={() => changeIndustry(item.info.code, item.info.name)}
                  className={[item.info.active ? 'active' : ''].join(' ')}>
                  {item.info.name}
                </CButton>
              </section>
            ))}
          </section>
          <section className="industry-0201">
            {currentIndustry.map((child: any, index: number) => (
              <EButton key={index}
                onClick={() => changeSubIndustry(child.code, child.name)}
                className={[child.active ? 'active' : ''].join(' ')}>{child.name}
              </EButton>
            ))}
          </section>
        </section>
      </section>
    </DModal>
  );
};

export default observer(SingleIndustry);
